import React, { useState, useEffect } from "react";

interface QuestionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (question: string) => void;
}

const QuestionModal: React.FC<QuestionModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [question, setQuestion] = useState("");

  // 모달 스크롤 방지 효과
  useEffect(() => {
    if (isOpen) {
      // 스크롤 위치 저장
      const scrollY = window.scrollY;

      // body에 modal-open 클래스 추가
      document.body.classList.add("modal-open");

      // 스크롤 위치 설정
      document.body.style.top = `-${scrollY}px`;

      // 정리 함수
      return () => {
        document.body.classList.remove("modal-open");
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (question.trim() === "") return;
    onSubmit(question);
    setQuestion("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>질문하기</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="question-form">
            <textarea
              className="question-textarea"
              placeholder="질문을 입력하세요..."
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              rows={5}
            />
            <p className="question-instruction">
              Please enter in English only.
            </p>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={handleSubmit}
            disabled={question.trim() === ""}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionModal;
